import { createAction } from 'actions/utils'

export const SET_QUERY_EVALUATION = 'SET_QUERY_EVALUATION'
export const setQueryEvaluation = (queryUri, queryLabel, value) => ({
  queryUri,
  queryLabel,
  value,
  type: SET_QUERY_EVALUATION,
})

export const SET_QUERY_FIELD = 'SET_QUERY_FIELD'
export const setQueryField = (queryUri, paramName, value) => ({
  type: SET_QUERY_FIELD,
  queryUri,
  paramName,
  value,
})

export const RESET_QUERY = 'RESET_QUERY'
export const resetQuery = createAction(RESET_QUERY, [
  'id',
  'fnId',
  'resetOptions',
])

export const RESET_CONDITION_FLOATING_CIRCUITS =
  'RESET_CONDITION_FLOATING_CIRCUITS'
export const resetConditionFloatingCircuits = createAction(
  RESET_CONDITION_FLOATING_CIRCUITS,
  ['uris']
)
